import { useEffect, DependencyList } from 'react';

/**
 * Custom hook to add scroll reveal animation to elements
 * Elements with 'scroll-reveal' class will animate into view when scrolled
 * @param deps - Optional dependencies to re-run the observer when content changes
 */
export const useScrollReveal = (deps?: DependencyList) => {
  useEffect(() => {
    // Small delay to ensure DOM is updated with new content
    const timeoutId = setTimeout(() => {
      const observerOptions: IntersectionObserverInit = {
        root: null,
        threshold: 0.1,
        rootMargin: '0px'
      };

      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('revealed');
            observer.unobserve(entry.target);
          }
        });
      }, observerOptions);

      const elements = document.querySelectorAll('.scroll-reveal');
      elements.forEach(element => {
        observer.observe(element);
      });

      return () => {
        elements.forEach(element => {
          observer.unobserve(element);
        });
      };
    }, 100);

    return () => clearTimeout(timeoutId);
  }, deps || []);
};
